import React, { useEffect, useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import RDSIcon from 'react-aws-icons/dist/aws/logo/RDS';
import EC2Icon from 'react-aws-icons/dist/aws/logo/EC2';
import S3Icon from 'react-aws-icons/dist/aws/logo/S3';
import LandscapeTable from 'SensitiveDataLandscape/Components/LandscapeTable';
import { SiSnowflake, SiMongodb } from 'react-icons/si';
import { HiOutlineDatabase } from 'react-icons/hi';
import { filterLandscapeData } from 'SensitiveDataLandscape/LandscapeUtils';
import PageHeader from 'Utils/PageHeader';
import { getLandscapeHomeSummary, mapSummaryToRiskRows } from 'SensitiveDataLandscape/homeSummaryApi';

const sourceIcons = {
  'rds': RDSIcon,
  'ec2': EC2Icon,
  's3': S3Icon,
  'mongodb': SiMongodb,
  'snowflake': SiSnowflake,
  'external': HiOutlineDatabase
};

const RiskByService = (props) => {
  const fetchingData = props.fetchingData;
  const landscapeData = props.landscapeData || { sources: [] };
  const { source } = useParams();
  const [homeSummary, setHomeSummary] = useState(null);

  useEffect(() => {
    const loadSummary = async () => {
      try {
        const response = await getLandscapeHomeSummary();
        setHomeSummary(response);
      } catch (e) {
        console.log('Error loading landscape home summary for RiskByService', e);
      }
    };
    loadSummary();
  }, []);

  const landscapeTableData = homeSummary
    ? mapSummaryToRiskRows(homeSummary, source)
    : filterLandscapeData(landscapeData.sources, source);
  return (
    <Container>
      <PageHeader
        header={`Your ${source} Risk`}
        icon={sourceIcons[source] || sourceIcons['external']}
        disabledActions={true}
        tooltip={<span>Here are all of your <span className='text-uppercase'>{source}</span> data source and their risk findings.</span>}
      />
      <Row className='widget-row'>
        <Col>
          <LandscapeTable
            fetchingData={fetchingData}
            landscapeData={landscapeTableData}
            pageSize={10}
          />
        </Col>
      </Row>
    </Container>
  )
}

export default RiskByService;